import { CoreIcon } from '../core-icon';
import mochiCoinColorGraySVG from '../../assets/icons/mochi-coin-color-gray.svg';
import type { IconProps } from '../core-icon';

export const MochiCoinColorGrayIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mochiCoinColorGraySVG} {...props} />;
};
